import { __module as s } from "../../../../_virtual/scopeTab.js";
import { t as _ } from "./tabbable.js";
(function(c, f) {
  Object.defineProperty(f, "__esModule", {
    value: !0
  }), f.default = g;
  var d = _, p = m(d);
  function m(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function v() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return e.activeElement.shadowRoot ? v(e.activeElement.shadowRoot) : e.activeElement;
  }
  function g(e, r) {
    var a = (0, p.default)(e);
    if (!a.length) {
      r.preventDefault();
      return;
    }
    var t = void 0, n = r.shiftKey, o = a[0], u = a[a.length - 1], i = v();
    if (e === i) {
      if (!n) return;
      t = u;
    }
    if (u === i && !n && (t = o), o === i && n && (t = u), t) {
      r.preventDefault(), t.focus();
      return;
    }
    var b = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), h = b != null && b[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (h) {
      var l = a.indexOf(i);
      if (l > -1 && (l += n ? -1 : 1), t = a[l], typeof t > "u") {
        r.preventDefault(), t = n ? u : o, t.focus();
        return;
      }
      r.preventDefault(), t.focus();
    }
  }
  c.exports = f.default;
})(s, s.exports);
var D = s.exports;
export {
  D as s
};
